import * as React from "react";
import { forwardRef } from "react";
const SvgDriveDark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.25 15.5H3.75C2.50725 15.5 1.5 14.4928 1.5 13.25V4.25H14.25C15.4928 4.25 16.5 5.25725 16.5 6.5V13.25C16.5 14.4928 15.4928 15.5 14.25 15.5Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M8.25 4.25H1.5V3.5C1.5 2.67125 2.17125 2 3 2H6.4185C7.06425 2 7.63725 2.41325 7.84125 3.026L8.25 4.25Z", fill: "#AFAFAF" }));
const ForwardRef = forwardRef(SvgDriveDark);
export { ForwardRef as ReactComponent };
